// One-at-a-time queue for app-launch popups (location, notifications, rating).
let active = null;
const waiters = [];

const flush = () => {
  // Bail while a sheet blocks popups, otherwise a blocked waiter re-queues itself forever.
  while (!active && !blockers.size && waiters.length) waiters.shift()();
};

export function claimPopup(name) {
  if (blockers.size || (active && active !== name)) return false;
  active = name;
  return true;
}

// Holds back launch popups while a user-opened sheet (e.g. payment) is on screen.
const blockers = new Set();
export function blockPopups(name) {
  blockers.add(name);
}
export const popupsBlocked = () => blockers.size > 0;
export function unblockPopups(name) {
  if (!blockers.delete(name)) return;
  setTimeout(flush, 600);
}

export function releasePopup(name) {
  if (active !== name) return;
  active = null;
  // Short gap so the next sheet slides in after the previous one has closed.
  setTimeout(flush, 600);
}

// Runs `cb` once no other launch popup is showing; returns a cancel function.
export function whenPopupFree(name, cb) {
  const run = () => { if (claimPopup(name)) cb(); else waiters.push(run); };
  run();
  return () => {
    const i = waiters.indexOf(run);
    if (i >= 0) waiters.splice(i, 1);
  };
}
